// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  tinyMceApiKey: "n9corkj5s96kyvam2t6eiumf3wg12uhasueljvcrm5la5jyl", //'lnqlfpye2uzs3g7zrixou3389urpijp3dnvfn1jgxpv7ke4x'
};
